module.exports = __webpack_public_path__ + "components/country-flag/static/cd-e8fbc1249f51344489420911034d724a.svg";